import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import { Link } from '@/components/links';
import { StackCards } from '@/components/StackCards';
import { Card } from '@/components/StackCards/types';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconPay from '@/assets/icons/heroIcons/Pay.svg';
import IconRewards from '@/assets/icons/heroIcons/Rewards.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconLightBulb from '@/assets/icons/heroIcons/Light-bulb.svg';
import { AccountsAndRewards } from '@/sections/AccountsAndRewards';
import Hero from '@/sections/Hero';
import Eshops from '@/sections/Eshops';
import MoreInfoSection from '@/sections/MoreInfo';
import { FaqIntro } from '@/sections/FaqIntro';
import { Testimonials as TestimonialsSection } from '@/sections/Testimonials';
import { Button } from '@/components/buttons';
import { InfoBoxes } from '@/components/boxes';
import { BenefitTiles } from '@/components/tiles';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Text } from '@/components/typography';
import { type IntlProps, getIntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { Trans, useTranslation } from 'react-i18next';
import { LINKS } from '@/constants/links';
import React from 'react';
import { mergeClasses } from '@/utils/style';
import { NumericRange } from '@/types/range';
import { getPageBannerWithPromoSourceBySlug, PageBanner } from '@/api/sanity/pageBanners';
import { getTestimonialsBySlug, Testimonial } from '@/api/sanity/testimonials';
import { SeoHeader } from '@/components/SeoHeader';
import { type EshopsList, getAffiliateEshopsList } from '@/api/sanity/affiliateEshopsList';
import { AnimatedSection, AnimatedContent } from '@/components/animation';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { showChristmasOffer } from '@/utils/christmas';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import usePromoSource from '@/hooks/usePromoSource';
import { useClientOnly } from '@/hooks/useClientOnly';
import { getSectionAnchorId } from '@/utils/anchors';
import { showSpringOffer } from '@/utils/springOffer';
import IconTulip from '@/assets/icons/heroIcons/Tulip.svg';
interface Props extends IntlProps {
  pageBanners: PageBanner[] | null;
  eshops: EshopsList;
  testimonials: Testimonial[];
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(props) {
  const $ = _c(180);
  usePageView("deferred-payment");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["deferredPayment", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    pageBanners,
    eshops,
    menuPromoBanners,
    testimonials
  } = props;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = showSpringOffer();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldShowSpringOffer = t1;
  let t2;
  if ($[2] !== t) {
    t2 = Array.from({
      length: 5
    }, (_, index) => {
      const cardIndex = index + 1 as NumericRange<1, 5>;
      return {
        index,
        menuTitle: "",
        title: <div className={mergeClasses(cardIndex === 5 && "text-center lg:text-left")}>{t(`howItWorks.items.${cardIndex}.title`)}</div>,
        ...(cardIndex < 5 ? {
          description: cardIndex === 1 ? <Trans t={t} i18nKey={`howItWorks.items.${cardIndex}.text`}><Link to={LINKS().whereToShop} analyticsParam="deferredPaymenthowItWorksPartners" testId="deferredPaymenthowItWorksPartners" /><Link target="_blank" to="https://promo.skippay.cz/bank-id/" analyticsParam="deferredPaymenthowItWorksBankID" testId="deferredPaymenthowItWorksBankID" /></Trans> : t(`howItWorks.items.${cardIndex}.text`)
        } : {
          footer: <Button analyticsParam="deferredPaymenthowItWorksiWantMaxi" testId="deferredPaymenthowItWorksiWantMaxi" variant="primary" size="lg" className="m-auto w-full md:w-auto lg:m-0" to={LINKS().registration}>{t(`howItWorks.items.${cardIndex}.text`)}</Button>
        }),
        images: {
          desktop: {
            src: `/images/sections/deferredPayment/cards/cs/${cardIndex}.png`,
            alt: t(`howItWorks.items.${cardIndex}.title`)
          },
          mobile: {
            src: cardIndex === 1 ? `/images/sections/deferredPayment/cards/cs/mobile/${cardIndex}.png` : `/images/sections/deferredPayment/cards/cs/${cardIndex}.png`,
            alt: t(`howItWorks.items.${cardIndex}.title`)
          },
          ...(cardIndex < 5 && {
            variant: "appMockup"
          })
        }
      };
    });
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const cards = t2;
  const promoSource = usePromoSource();
  const {
    isClient
  } = useClientOnly();
  let t3;
  if ($[4] !== isClient || $[5] !== pageBanners || $[6] !== promoSource) {
    t3 = isClient && promoSource && pageBanners?.find(banner_0 => banner_0.promoSource === promoSource) || pageBanners?.find(_temp);
    $[4] = isClient;
    $[5] = pageBanners;
    $[6] = promoSource;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const pageBanner = t3;
  let t4;
  if ($[8] !== t) {
    t4 = t("seo.title");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("seo.description");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <SeoHeader title={t4} description={t5} />;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = pageBanner ? pageBanner.videoId : "BCyXQ3Kx4zY";
  let t8;
  if ($[15] !== pageBanner?.title || $[16] !== t) {
    t8 = pageBanner?.title ?? t("banner.title");
    $[15] = pageBanner?.title;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== pageBanner?.text || $[19] !== t) {
    t9 = pageBanner?.text ?? t("banner.text");
    $[18] = pageBanner?.text;
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== pageBanner || $[22] !== t) {
    t10 = pageBanner ? pageBanner.buttons : [{
      ariaLabel: t("banner.cta"),
      label: t("banner.cta"),
      to: LINKS().registration,
      testId: "deferredPaymentHeroPrimaryCTA",
      analyticsParam: "deferredPaymentHeroPrimaryCTA",
      variant: "primary"
    }];
    $[21] = pageBanner;
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = pageBanner?.image?.url ?? "/images/sections/deferredPayment/hero/hero.png";
  let t12;
  if ($[24] !== pageBanner?.image?.alt || $[25] !== t) {
    t12 = pageBanner?.image?.alt ?? t("banner.title");
    $[24] = pageBanner?.image?.alt;
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = {
      url: t11,
      alt: t12
    };
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const t14 = pageBanner?.variant || "products";
  let t15;
  if ($[30] !== t10 || $[31] !== t13 || $[32] !== t14 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t15 = <Hero videoId={t7} title={t8} text={t9} buttons={t10} image={t13} variant={t14} />;
    $[30] = t10;
    $[31] = t13;
    $[32] = t14;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = getSectionAnchorId("advantages");
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t("advantages.title");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17) {
    t18 = <SectionHeadline className="mb-10 lg:mb-16" variant="inverted" anchorKey="advantages.title">{t17}</SectionHeadline>;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t) {
    t19 = t("advantages.items.1.title");
    $[42] = t;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t) {
    t20 = t("advantages.items.1.text");
    $[44] = t;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <IconDeferredPayment />;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t19 || $[48] !== t20) {
    t22 = {
      title: t19,
      paragraph: t20,
      icon: t21
    };
    $[47] = t19;
    $[48] = t20;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t) {
    t23 = t("advantages.items.2.title");
    $[50] = t;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t) {
    t24 = t("advantages.items.2.text");
    $[52] = t;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <IconPay />;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t23 || $[56] !== t24) {
    t26 = {
      title: t23,
      paragraph: t24,
      icon: t25
    };
    $[55] = t23;
    $[56] = t24;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== t) {
    t27 = shouldShowSpringOffer ? t("advantages.items.spring.title") : t("advantages.items.3.title");
    $[58] = t;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t) {
    t28 = shouldShowSpringOffer ? t("advantages.items.spring.text") : t("advantages.items.3.text");
    $[60] = t;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = shouldShowSpringOffer ? <IconTulip /> : <IconRewards />;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  let t30;
  if ($[63] !== t27 || $[64] !== t28) {
    t30 = {
      title: t27,
      paragraph: t28,
      icon: t29
    };
    $[63] = t27;
    $[64] = t28;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] !== t22 || $[67] !== t26 || $[68] !== t30) {
    t31 = <InfoBoxes items={[t22, t26, t30]} variant="inverted" withCharacters={true} />;
    $[66] = t22;
    $[67] = t26;
    $[68] = t30;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = LINKS();
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  const t33 = t32.registration;
  let t34;
  if ($[71] !== t) {
    t34 = t("advantages.cta");
    $[71] = t;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] !== t34) {
    t35 = <Button to={t33} testId="deferredPaymentRegistration" analyticsParam="deferredPaymentRegistration" size="lg" variant="primary" align="center" className="mt-12 md:mt-16">{t34}</Button>;
    $[73] = t34;
    $[74] = t35;
  } else {
    t35 = $[74];
  }
  let t36;
  if ($[75] !== t18 || $[76] !== t31 || $[77] !== t35) {
    t36 = <AnimatedContent className="px-4 pb-10 lg:pb-20">{t18}{t31}{t35}</AnimatedContent>;
    $[75] = t18;
    $[76] = t31;
    $[77] = t35;
    $[78] = t36;
  } else {
    t36 = $[78];
  }
  let t37;
  if ($[79] !== t) {
    t37 = t("howItWorks.title");
    $[79] = t;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  let t38;
  if ($[81] !== t37) {
    t38 = <SectionHeadline className="mb-10 px-4 md:mb-16" variant="inverted" anchorKey="howItWorks.title">{t37}</SectionHeadline>;
    $[81] = t37;
    $[82] = t38;
  } else {
    t38 = $[82];
  }
  let t39;
  if ($[83] !== cards) {
    t39 = <StackCards imagePosition="left" cards={cards} />;
    $[83] = cards;
    $[84] = t39;
  } else {
    t39 = $[84];
  }
  let t40;
  if ($[85] !== t38 || $[86] !== t39) {
    t40 = <AnimatedContent className="pt-10 pb-14 lg:pt-20 lg:pb-32">{t38}{t39}</AnimatedContent>;
    $[85] = t38;
    $[86] = t39;
    $[87] = t40;
  } else {
    t40 = $[87];
  }
  let t41;
  if ($[88] !== t36 || $[89] !== t40) {
    t41 = <AnimatedSection bgColor="bg-blue-900" id={t16}>{t36}{t40}</AnimatedSection>;
    $[88] = t36;
    $[89] = t40;
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  let t42;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = getSectionAnchorId("deferredPayment");
    $[91] = t42;
  } else {
    t42 = $[91];
  }
  let t43;
  if ($[92] !== eshops) {
    t43 = <AnimatedContent className="pb-10 lg:pb-20"><Eshops eshops={eshops} /></AnimatedContent>;
    $[92] = eshops;
    $[93] = t43;
  } else {
    t43 = $[93];
  }
  let t44;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <AnimatedContent className="py-10 lg:py-20"><AccountsAndRewards /></AnimatedContent>;
    $[94] = t44;
  } else {
    t44 = $[94];
  }
  let t45;
  if ($[95] !== t) {
    t45 = t("deferredPayment.title");
    $[95] = t;
    $[96] = t45;
  } else {
    t45 = $[96];
  }
  let t46;
  if ($[97] !== t45) {
    t46 = <SectionHeadline className="mb-5" anchorKey="deferredPayment.title">{t45}</SectionHeadline>;
    $[97] = t45;
    $[98] = t46;
  } else {
    t46 = $[98];
  }
  let t47;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <Link to={LINKS().revolving} testId="deferredPaymentAboutRevolving" analyticsParam="deferredPaymentAboutRevolving" />;
    $[99] = t47;
  } else {
    t47 = $[99];
  }
  let t48;
  if ($[100] !== t) {
    t48 = <Text variant="p2" className="text-gray-800"><Trans t={t} i18nKey="deferredPayment.text">{t47}</Trans></Text>;
    $[100] = t;
    $[101] = t48;
  } else {
    t48 = $[101];
  }
  let t49;
  if ($[102] !== t46 || $[103] !== t48) {
    t49 = <div className="mx-auto w-full max-w-[50rem] text-center">{t46}{t48}</div>;
    $[102] = t46;
    $[103] = t48;
    $[104] = t49;
  } else {
    t49 = $[104];
  }
  let t50;
  if ($[105] !== t) {
    t50 = t("deferredPayment.items.1.title");
    $[105] = t;
    $[106] = t50;
  } else {
    t50 = $[106];
  }
  let t51;
  if ($[107] !== t50) {
    t51 = {
      title: t50
    };
    $[107] = t50;
    $[108] = t51;
  } else {
    t51 = $[108];
  }
  let t52;
  let t53;
  if ($[109] !== t) {
    t52 = showChristmasOffer() ? {
      title: t("deferredPayment.items.christmas.title")
    } : shouldShowSpringOffer ? {
      title: t("deferredPayment.items.spring.title")
    } : {
      title: t("deferredPayment.items.2.title")
    };
    t53 = t("deferredPayment.items.3.title");
    $[109] = t;
    $[110] = t52;
    $[111] = t53;
  } else {
    t52 = $[110];
    t53 = $[111];
  }
  let t54;
  if ($[112] !== t53) {
    t54 = {
      title: t53
    };
    $[112] = t53;
    $[113] = t54;
  } else {
    t54 = $[113];
  }
  let t55;
  if ($[114] !== t51 || $[115] !== t52 || $[116] !== t54) {
    t55 = <div className="my-8 mb-12 md:my-16"><BenefitTiles items={[t51, t52, t54].filter(Boolean)} /></div>;
    $[114] = t51;
    $[115] = t52;
    $[116] = t54;
    $[117] = t55;
  } else {
    t55 = $[117];
  }
  let t56;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = LINKS();
    $[118] = t56;
  } else {
    t56 = $[118];
  }
  const t57 = t56.revolving;
  let t58;
  if ($[119] !== t) {
    t58 = t("deferredPayment.cta");
    $[119] = t;
    $[120] = t58;
  } else {
    t58 = $[120];
  }
  let t59;
  if ($[121] !== t58) {
    t59 = <Button to={t57} testId="deferredPaymentRevolving" analyticsParam="deferredPaymentRevolving" size="lg" variant="primary" align="center">{t58}</Button>;
    $[121] = t58;
    $[122] = t59;
  } else {
    t59 = $[122];
  }
  let t60;
  if ($[123] !== t49 || $[124] !== t55 || $[125] !== t59) {
    t60 = <AnimatedContent className="px-4 pt-10 lg:pt-20">{t49}{t55}{t59}</AnimatedContent>;
    $[123] = t49;
    $[124] = t55;
    $[125] = t59;
    $[126] = t60;
  } else {
    t60 = $[126];
  }
  let t61;
  if ($[127] !== t43 || $[128] !== t60) {
    t61 = <AnimatedSection bgColor="bg-blue-50" id={t42}>{t43}{t44}{t60}</AnimatedSection>;
    $[127] = t43;
    $[128] = t60;
    $[129] = t61;
  } else {
    t61 = $[129];
  }
  let t62;
  if ($[130] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = getSectionAnchorId("moreInfo");
    $[130] = t62;
  } else {
    t62 = $[130];
  }
  let t63;
  if ($[131] !== testimonials) {
    t63 = <AnimatedContent className="relative z-10 pb-10 lg:pb-20"><TestimonialsSection testimonials={testimonials} /></AnimatedContent>;
    $[131] = testimonials;
    $[132] = t63;
  } else {
    t63 = $[132];
  }
  let t64;
  if ($[133] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = LINKS();
    $[133] = t64;
  } else {
    t64 = $[133];
  }
  let t65;
  if ($[134] === Symbol.for("react.memo_cache_sentinel")) {
    t65 = <Link to="/caste-dotazy/odlozena-platba" analyticsParam="faqDeferredPayment" testId="faqDeferredPayment" />;
    $[134] = t65;
  } else {
    t65 = $[134];
  }
  let t66;
  if ($[135] !== t) {
    t66 = <AnimatedContent className="relative z-10 py-10 lg:py-20"><FaqIntro link={t64.faq} text={<Trans i18nKey="faq.text" t={t}>{t65}</Trans>} /></AnimatedContent>;
    $[135] = t;
    $[136] = t66;
  } else {
    t66 = $[136];
  }
  let t67;
  if ($[137] === Symbol.for("react.memo_cache_sentinel")) {
    t67 = <IconThird className="fillButtonIcon" />;
    $[137] = t67;
  } else {
    t67 = $[137];
  }
  let t68;
  if ($[138] !== t) {
    t68 = t("core:products.payInThree");
    $[138] = t;
    $[139] = t68;
  } else {
    t68 = $[139];
  }
  let t69;
  if ($[140] === Symbol.for("react.memo_cache_sentinel")) {
    t69 = LINKS();
    $[140] = t69;
  } else {
    t69 = $[140];
  }
  let t70;
  if ($[141] !== t68) {
    t70 = {
      analyticsParam: "deferredPaymentMoreInfoPayInThree",
      icon: t67,
      testId: "deferredPaymentMoreInfoPayInThree",
      title: t68,
      to: t69.payInThree
    };
    $[141] = t68;
    $[142] = t70;
  } else {
    t70 = $[142];
  }
  let t71;
  if ($[143] === Symbol.for("react.memo_cache_sentinel")) {
    t71 = <IconMaxi className="fillButtonIcon" />;
    $[143] = t71;
  } else {
    t71 = $[143];
  }
  let t72;
  if ($[144] !== t) {
    t72 = t("core:products.revolving");
    $[144] = t;
    $[145] = t72;
  } else {
    t72 = $[145];
  }
  let t73;
  if ($[146] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = LINKS();
    $[146] = t73;
  } else {
    t73 = $[146];
  }
  let t74;
  if ($[147] !== t72) {
    t74 = {
      analyticsParam: "deferredPaymentMoreInfoRevolvingApplication",
      icon: t71,
      testId: "deferredPaymentMoreInfoRevolvingApplication",
      title: t72,
      to: t73.revolving
    };
    $[147] = t72;
    $[148] = t74;
  } else {
    t74 = $[148];
  }
  let t75;
  if ($[149] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = <IconCard className="fillButtonIcon" />;
    $[149] = t75;
  } else {
    t75 = $[149];
  }
  let t76;
  if ($[150] !== t) {
    t76 = t("core:products.card");
    $[150] = t;
    $[151] = t76;
  } else {
    t76 = $[151];
  }
  let t77;
  if ($[152] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = LINKS();
    $[152] = t77;
  } else {
    t77 = $[152];
  }
  let t78;
  if ($[153] !== t76) {
    t78 = {
      analyticsParam: "deferredPaymentMoreInfoCard",
      icon: t75,
      testId: "deferredPaymentMoreInfoCard",
      title: t76,
      to: t77.card
    };
    $[153] = t76;
    $[154] = t78;
  } else {
    t78 = $[154];
  }
  let t79;
  if ($[155] === Symbol.for("react.memo_cache_sentinel")) {
    t79 = <IconLightBulb className="fillButtonIcon" />;
    $[155] = t79;
  } else {
    t79 = $[155];
  }
  let t80;
  if ($[156] !== t) {
    t80 = t("core:link.shopWisely");
    $[156] = t;
    $[157] = t80;
  } else {
    t80 = $[157];
  }
  let t81;
  if ($[158] === Symbol.for("react.memo_cache_sentinel")) {
    t81 = LINKS();
    $[158] = t81;
  } else {
    t81 = $[158];
  }
  let t82;
  if ($[159] !== t80) {
    t82 = {
      analyticsParam: "deferredPaymentMoreInfoShopWisely",
      icon: t79,
      testId: "deferredPaymentMoreInfoShopWisely",
      title: t80,
      to: t81.shopWisely
    };
    $[159] = t80;
    $[160] = t82;
  } else {
    t82 = $[160];
  }
  let t83;
  if ($[161] !== t70 || $[162] !== t74 || $[163] !== t78 || $[164] !== t82) {
    t83 = <AnimatedContent className="relative z-10"><MoreInfoSection buttons={[t70, t74, t78, t82]} /></AnimatedContent>;
    $[161] = t70;
    $[162] = t74;
    $[163] = t78;
    $[164] = t82;
    $[165] = t83;
  } else {
    t83 = $[165];
  }
  let t84;
  let t85;
  let t86;
  if ($[166] === Symbol.for("react.memo_cache_sentinel")) {
    t84 = <div className="bgCircle absolute top-1/4 right-0 translate-x-1/3 rotate-270 md:hidden" />;
    t85 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    t86 = <div className="bgCircle absolute top-0 left-0 -translate-x-1/2 translate-y-1/4 rotate-180" />;
    $[166] = t84;
    $[167] = t85;
    $[168] = t86;
  } else {
    t84 = $[166];
    t85 = $[167];
    t86 = $[168];
  }
  let t87;
  if ($[169] !== t63 || $[170] !== t66 || $[171] !== t83) {
    t87 = <AnimatedSection bgColor="bg-blue-100" className="pb-0!" id={t62}><div className="relative overflow-hidden">{t63}{t66}{t83}{t84}{t85}{t86}</div></AnimatedSection>;
    $[169] = t63;
    $[170] = t66;
    $[171] = t83;
    $[172] = t87;
  } else {
    t87 = $[172];
  }
  let t88;
  if ($[173] !== menuPromoBanners || $[174] !== t15 || $[175] !== t41 || $[176] !== t6 || $[177] !== t61 || $[178] !== t87) {
    t88 = <Layout menuPromoBanners={menuPromoBanners}>{t6}{t15}{t41}{t61}{t87}</Layout>;
    $[173] = menuPromoBanners;
    $[174] = t15;
    $[175] = t41;
    $[176] = t6;
    $[177] = t61;
    $[178] = t87;
    $[179] = t88;
  } else {
    t88 = $[179];
  }
  return t88;
}
function _temp(banner) {
  return !banner.promoSource;
}
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('platba-skip-pay');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      pageBanners: await getPageBannerWithPromoSourceBySlug('deferred-payment'),
      testimonials: await getTestimonialsBySlug('deferred-payment'),
      eshops: await getAffiliateEshopsList('deferred-payment'),
      ...(await getIntlProps(ctx, ['core', 'eshops', 'deferredPayment', 'homepage', 'testimonials']))
    }
  };
}) satisfies GetStaticProps<Props>;